<div class="geojson-upload-dialog">
  <h2 mat-dialog-title i18n="@@bulk-add-locations.geojson.title">
    Bulk-add locations via GeoJson files
  </h2>

  @if ((invalidFiles | async)?.length) {
    <div class="error-container">
      <p i18n="@@bulk-add-locations.geojson.error.unsupported">
        The following files cannot be used as they are not supported:
      </p>
      <div class="error-list">
        @for (file of invalidFiles | async; track file.fileName) {
          <div class="error-item">
            <span>{{ file.fileName }} {{ file.size ? "(" + file.size + ")" : "" }}</span>
            <span class="error-message">{{ file.error }}</span>
          </div>
        }
      </div>
    </div>
  } @else {
    <mat-dialog-content>
      <app-upload-files-box
        [maxSizeInMb]="maxFileSizeInMb"
        [maxFiles]="maxNumberOfFiles"
        [shouldNotifyOnFileError]="false"
        [supportedFileTypes]="supportedFileTypes"
        [validate]="true"
        (filesSelected)="onFilesSelected($event)"
        [footerLeftText]="translations.uploadBoxFooterLeftText"
        [footerRightText]="translations.uploadBoxFooterRightText"
      ></app-upload-files-box>

      <div class="file-info">{{ translations.fileInfo }}</div>
    </mat-dialog-content>
  }

  <mat-dialog-actions>
    <app-button-group>
      <app-button (pressed)="onClose()" type="ghost">
        <ng-container>{{ translations.cancel }}</ng-container>
      </app-button>
      @if ((invalidFiles | async)?.length && (hasValidLocations | async)) {
        <app-button (pressed)="onClickSkipFiles()" color="primary">
          <ng-container i18n="@@bulk-add-locations.geojson.skip">Skip files</ng-container>
        </app-button>
      }
    </app-button-group>
  </mat-dialog-actions>
</div>
